<template>
    <v-card class="mb-6 mt-3"
            :style="'border: solid ' + getPeriodColors(priceDiff).deep + ' 1px'">
        <v-app-bar dark class="period-toolbar" height="auto"
                   :style="'background-color:' + getPeriodColors(priceDiff).light">
            <div class="d-flex justify-content-between w-100">
                <div
                  class="mt-auto mb-auto cmaj-title d-flex justify-content-between w-100">
                    <div class="d-flex gap-20">
                        <div :style="'color:' + getPeriodColors(priceDiff).deep">
                            Du <h4 :style="'color:' + getPeriodColors(priceDiff).deep">
                            {{ formatDate(data.valid_from, false) }}</h4>
                        </div>
                        <div :style="'color:' + getPeriodColors(priceDiff).deep">
                            au <h4 :style="'color:' + getPeriodColors(priceDiff).deep">
                            {{ formatDate(data.valid_through, false) }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </v-app-bar>

        <v-card-text style="font-size: 16px">
            <div v-if="data.prices.length">
                <div v-for="price in data.prices"
                     v-if="data.element !== null"
                     class="row border-bottom price-item">
                    <div class="col-3">
                        {{ price.element.label }}
                    </div>
                    <div class="col-3">
                        <div v-if="price.mode === 'MIN_MAX'">
                            De {{ price.min / 100 }}{{ data.currency.label }} à
                            {{ price.max / 100 }}{{
                                data.currency.label
                            }}
                        </div>
                        <div v-else-if="price.mode === 'FROM'">
                            À partir de {{ price.min / 100 }}{{ data.currency.label }}
                        </div>
                        <div v-else-if="price.mode === 'UNIQUE'">
                            {{ price.min / 100 }}{{ data.currency.label }}
                        </div>
                    </div>
                    <div class="col">
                        {{ price.detail }}
                    </div>
                </div>
            </div>
            <div v-else><b>Aucun tarif renseigné</b></div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "PricePeriodDiffCard",
    props: ["priceDiff", "data"],
    methods: {
        getPeriodColors(priceDiff) {
            if (priceDiff.old === null) {
                return this.addColors
            } else if (priceDiff.new !== null) {
                return this.updateColors
            } else {
                return this.deleteColors
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>